





























import { computed, defineComponent } from '@vue/composition-api'
import type { ItemExtras, OrderableItemData } from '@futureecom/futureecom-js/dist/services/cart-service'
import type { Product, ProductExtraOptions } from '@futureecom/futureecom-js/dist/services/catalog-service'
import type { PropType } from '@vue/composition-api'

export default defineComponent({
  name: 'OrderableAddProductSectionExtras',

  props: {
    value: {
      type: Object as PropType<OrderableItemData>,
      required: true
    },
    product: {
      type: Object as PropType<Product>,
      required: true
    }
  },

  setup(props, { emit }) {
    const orderableExtras = computed({
      get: () => props.value.extras || [],
      set: (extras) => {
        const filtered = extras.filter((item) => item.options.length > 0)
        emit('input', { ...props.value, extras: filtered.length ? filtered : undefined })
      }
    })

    const orderableExtrasOptions = (key: string) => {
      return computed(() => orderableExtras.value.find((item) => item.key === key)?.options || [])
    }

    const onOptionSelect = (extras: ItemExtras, options: ProductExtraOptions[]) => {
      const filteredExtras = orderableExtras.value.filter((item) => item.key !== extras.key)
      filteredExtras.push({ ...extras, options })
      orderableExtras.value = filteredExtras
    }

    const disableOption = (extrasKey: string, option: ProductExtraOptions) =>
      computed(() => {
        const extras = orderableExtras.value.find((item) => item.key === extrasKey)
        if (!extras?.limit) {
          return false
        }
        return !extras.options.find((item) => item === option) && extras.options.length === extras.limit
      })

    return {
      orderableExtras,
      orderableExtrasOptions,
      onOptionSelect,
      disableOption
    }
  }
})
